<template>
  <div class="mt-32 ml-28">
    <div class="flex">
      <img class="jira-clr-logo" src="/static/images/logos/jira_image.svg" alt="jira logo"/>
      <div class="jira-conf-header">
        <span>Jira Configuration</span>
      </div>
    </div>
    <div class="ml-70">
      <p>Following projects are configured with Confluera Application.</p>
      <p>
        For connecting a new Jira Project -
        <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'jira' } }">
          <a>click here.</a>
        </router-link>
      </p>

      <action-table-element
        ref="jiraConfigTable"
        v-if="jiraConfigurationsFetched"
        :height-offset="200"
        :columns="visiblejiraConfigColumns"
        :table-data="copyJiraConfigs"
        :actions="tableActions"
      ></action-table-element>
      <div v-else v-loading="!jiraConfigurationsFetched" class="pt-200"></div>

      <el-dialog title="Update Jira Configuration" :visible.sync="dialogFormVisible" @close="$refs['updateJiraConfigForm'].resetFields()">
        <el-form :model="selectedConfig" ref="updateJiraConfigForm" :rules="jiraConfigRules">
          <el-form-item label="Workspace URL"  prop="workspace_url">
            <el-input v-model="selectedConfig.workspace_url" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Email"  prop="email_id">
            <el-input v-model="selectedConfig.email_id" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Token"  prop="api_token">
            <el-input v-model="selectedConfig.api_token" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Project ID/Key"  prop="project_id">
            <el-input v-model="selectedConfig.project_id" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">Cancel</el-button>
          <el-button type="primary" @click="updateConfiguration(selectedConfig)">Confirm</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ActionTableElement from '@/components/table/ActionTableElement.vue'
import { jiraConfigMetaInfo } from '@/column-header/jira/jira-config-meta'
import { emailRe } from '@/utilities/regex/email'

import {
  JIRA_CONFIGURATION_REQUEST,
  JIRA_SETTING_DELETE_REQUEST,
  JIRA_SETTING_UPDATE_REQUEST
} from '@/store/modules/jira/jira-setting.type'

export default {
  name: 'JiraConfigurations',
  data() {
    return {
      jiraConfigurationsFetched: false,
      dialogFormVisible: false,
      copyJiraConfigs: {},
      jiraConfigColumns: jiraConfigMetaInfo.meta.columns,
      visiblejiraConfigColumns: jiraConfigMetaInfo.meta.columns,
      selectedConfig: {
        workspace_url: '',
        email_id: '',
        api_token: '',
        project_id: ''
      },
      tableActions: [
        {
          name: 'edit',
          icon: 'c-icon el-icon-edit',
          tooltip: 'Edit Jira Configuration',
          rbac: {
            subject: 'users',
            operation: 'write'
          },
          actionHandler: selection => {
            this.selectedConfig = _.cloneDeep(selection.row)
            this.dialogFormVisible = true
          }
        },
        {
          name: 'delete',
          icon: 'c-icon el-icon-delete',
          tooltip: 'Delete Jira Configuration',
          rbac: {
            subject: 'users',
            operation: 'write'
          },
          actionHandler: selection => {
            this.$confirm('Are you sure you want to delete?', 'Warning', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning'
            })
              .then(() => {
                this.$store
                  .dispatch(JIRA_SETTING_DELETE_REQUEST, {
                    projectID: selection.row.id
                  })
                  .then(resp => {
                    this.$message({
                      type: 'success',
                      message: 'Configuration deleted successfully.'
                    })
                    this.jiraConfigurationsFetched = false
                    this.callApi()
                  })
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: 'Operation cancelled'
                })
              })
          }
        }
      ],
      jiraConfigRules: {
        workspace_url: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              value = value.trim().toLowerCase()
              if (value.length) {
                callback()
              } else {
                callback(new Error("workspace url can't be blank"))
              }
            }
          }
        ],
        email_id: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              value = value.trim().toLowerCase()
              if (value.length) {
                emailRe.test(value) ? callback() : callback(new Error('Invalid email format'))
              } else {
                callback(new Error("email can't be blank"))
              }
            }
          }
        ],
        api_token: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              value = value.trim().toLowerCase()
              if (value.length) {
                callback()
              } else {
                callback(new Error("api token can't be blank"))
              }
            }
          }
        ],
        project_id: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              value = value.trim().toLowerCase()
              if (value.length) {
                callback()
              } else {
                callback(new Error("project id can't be blank"))
              }
            }
          }
        ]
      }
    }
  },
  methods: {
    getJiraSettings() {
      this.$store.dispatch(JIRA_CONFIGURATION_REQUEST).then(data => {
        this.jiraConfigurationsFetched = true
        this.copyJiraConfigs = _.cloneDeep(this.jiraConfigs)
        this.dialogFormVisible = false
      })
    },
    updateConfiguration(config) {
      this.$refs['updateJiraConfigForm'].validate(valid => {
        if (valid) {
          const data = {
            workspaceUrl: config.workspace_url,
            emailId: config.email_id,
            apiToken: config.api_token,
            projectId: config.project_id,
            id: config.id
          }
          this.$store.dispatch(JIRA_SETTING_UPDATE_REQUEST, data).then(_ => {
            this.jiraConfigurationsFetched = false
            this.callApi()
            this.$message({
              type: 'success',
              message: 'Configuration updated successfully.'
            })
          })
        }
      })
    },
    callApi() {
      this.getJiraSettings()
    }
  },
  computed: {
    ...mapGetters(['jiraConfigs'])
  },
  components: {ActionTableElement},
  created() {
    this.callApi()
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

>>> .el-table th > .cell {
  font-size: 12px;
  font-weight: normal;
}

>>> .el-icon-edit {
  cursor: pointer;
}

>>> .el-icon-delete {
  cursor: pointer;
}

.jira-clr-logo {
  width: 50px;
  height: 50px;
}

.jira-conf-header {
  margin-top: 16px;
  margin-left: 20px;
  font-weight: bold;
}

>>> .el-input__inner::-webkit-input-placeholder {
  color: #606266;
}

>>> .el-input__inner:-ms-input-placeholder,
>>> .el-input__inner::-ms-input-placeholder {
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/JiraConfigurations.vue